var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 6");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83D\\uDCF1\\u2705-Investments-(I)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Investment-switch---Accum---Current-investment-switch---D01",
  transform: "translate(-128.000000, -643.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(104.000000, 463.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(24.000000, 180.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFF0E0",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(8.000000, 8.000000)",
  fill: "#FF8200"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(3.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,0 C14.55,0 15,0.45 15,1 L15,1 L15,2 L16,2 C17.1,2 18,2.9 18,4 L18,4 L18,9 L16,9 L16,7 L2,7 L2,17 C2,17.55 2.45,18 3,18 L3,18 L7,18 L7,20 L2,20 C0.89,20 0,19.1 0,18 L0,18 L0.01,4 C0.01,2.9 0.89,2 2,2 L2,2 L3,2 L3,1 C3,0.45 3.45,0 4,0 C4.55,0 5,0.45 5,1 L5,1 L5,2 L13,2 L13,1 C13,0.45 13.45,0 14,0 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,11 C15.3260824,11 16.597852,11.5267842 17.5355339,12.4644661 C18.4732158,13.402148 19,14.6739176 19,16 C19,18.7614237 16.7614237,21 14,21 C11.2385763,21 9,18.7614237 9,16 C9,13.2385763 11.2385763,11 14,11 Z M14,13 C13.4477153,13 13,13.4477153 13,14 L13,14 L13,15 L12,15 C11.4871642,15 11.0644928,15.3860402 11.0067277,15.8833789 L11,16 C11,16.5522847 11.4477153,17 12,17 L12,17 L13,17 L13,18 C13,18.5128358 13.3860402,18.9355072 13.8833789,18.9932723 L14,19 C14.5522847,19 15,18.5522847 15,18 L15,18 L15,17 L16,17 C16.5128358,17 16.9355072,16.6139598 16.9932723,16.1166211 L17,16 C17,15.4477153 16.5522847,15 16,15 L16,15 L15,15 L15,14 C15,13.4871642 14.6139598,13.0644928 14.1166211,13.0067277 Z",
  id: "Combined-Shape"
})))))));

var SvgFutureContributions = function SvgFutureContributions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFutureContributions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/future-contributions.781fb56f.svg";
export { ForwardRef as ReactComponent };